import React from 'react';
import { ExternalLink, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { APP_CONFIG } from '@/constants/branding';
import { Link } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import '@/styles/provatio-unified-design.css';

const Footer = () => {
  const { currentLanguage } = useTranslation();
  const getPath = (path) => `/${currentLanguage}${path}`;

  const officialSources = [
    { name: 'STJ - Superior Tribunal de Justiça', url: 'https://www.stj.jus.br' },
    { name: 'STJ - Consulta Processual', url: 'https://processo.stj.jus.br' },
    { name: 'ITI - Validar Assinaturas', url: 'https://validar.iti.gov.br' },
  ];

  const quickLinks = [
    { label: 'Início', path: getPath('/') },
    { label: 'Sobre', path: getPath('/about') },
    { label: 'Contato', path: getPath('/contact') },
    { label: 'Termos de Uso', path: getPath('/terms') },
    { label: 'Privacidade', path: getPath('/privacy') },
  ];

  return (
    <footer className="border-t bg-[#193D6D] text-white provatio-unified">
      <div className="h-1 w-full bg-[#D4AF37]"></div>
      <div className="container py-12 max-w-7xl mx-auto px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src={APP_CONFIG.LOGO_URL || '/provatio-logo.png'} alt="PROVATIO Logo" style={{ height: '30px' }} className="object-contain filter brightness-0 invert" />
              <p className="font-bold text-[#D4AF37] text-xl">{APP_CONFIG.APP_NAME}</p>
            </div>
            <p className="text-sm text-white/80 leading-relaxed max-w-md">
              {APP_CONFIG.APP_FULL_NAME} e Biblioteca Jurídica Forense.
              <br /><br />
              Análise técnica fundamentada, rastreabilidade e compliance com padrões oficiais para o ecossistema jurídico moderno.
            </p>
            <div className="flex items-center gap-4 mt-6 text-[#D4AF37]">
              <a href="#" aria-label="Facebook" className="hover:text-white transition-colors"><Facebook size={20} /></a>
              <a href="#" aria-label="Twitter" className="hover:text-white transition-colors"><Twitter size={20} /></a>
              <a href="#" aria-label="LinkedIn" className="hover:text-white transition-colors"><Linkedin size={20} /></a>
              <a href="#" aria-label="Instagram" className="hover:text-white transition-colors"><Instagram size={20} /></a>
            </div>
          </div>

          <div>
            <p className="font-semibold mb-4 text-[#D4AF37] text-lg">Links Úteis</p>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/90 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-semibold mb-4 text-[#D4AF37] text-lg">Fontes Oficiais</p>
            <ul className="space-y-3">
              {officialSources.map((source) => (
                <li key={source.url}>
                  <a
                    href={source.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-white/90 hover:text-[#D4AF37] inline-flex items-center gap-1.5 transition-colors"
                  >
                    {source.name}
                    <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-white/20" />

        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-white/60">
          <p>© {new Date().getFullYear()} {APP_CONFIG.APP_NAME} - {APP_CONFIG.APP_FULL_NAME}. Todos os direitos reservados.</p>
          <p className="mt-2 md:mt-0">Suporte: <a href={`mailto:${APP_CONFIG.SUPPORT_EMAIL}`} className="hover:text-[#D4AF37]">{APP_CONFIG.SUPPORT_EMAIL}</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;